<template>
  <div>
    <section class="subpage-head"><div class="container"><h1>Edit {{ entity }}</h1></div></section>
    <section class="login-reg">
      <div class="container">
        <div class="log-box main">
          <form class="gen-form" v-on:submit.prevent="saveProfile">
            <div class="form-row">
              <label>Discount code</label>
              <input type="text" v-model="item.code" />
            </div>
            <template v-if="entity=='DiscountCode'">
            <div class="form-row">
              <label>Active</label>
              <select v-model="item.active">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="form-row">
              <label>Parent</label>
              <select v-model="item.parent">
                <option :value="null">(no parent)</option>
                <option v-for="parent of types" :value="parent.id" v-if="parent.id!=item.id">{{ parent.title }}</option>
              </select>
            </div>
            </template>
            <template v-if="entity=='VideoGroup'">
            <div class="form-row split">
            <div>
              <label>30 days (USD)</label>
              <input type="text" v-model="item.priceUsd" />
            </div>
            <div>
              <label>30 days (regular price)</label>
              <input type="text" v-model="item.priceEur" />
            </div>
            </div>
            <div class="form-row split">
            <div>
              <label>90 days (USD)</label>
              <input type="text" v-model="item.renewPriceUsd" />
            </div>
            <div>
              <label>90 days (regular price)</label>
              <input type="text" v-model="item.renewPriceEur" />
            </div>
<!--            <div>
              <label style="white-space: nowrap">Duration (days)</label>
              <input type="text" v-model="item.duration" />
            </div>-->
            </div>
<!--            <div class="form-row">
              <label>Renew Prices</label>
            </div>-->
            <div class="form-row split">
            <div>
              <label>180 days (USD)</label>
              <input type="text" v-model="item.renewPrice2Usd" />
            </div>
            <div>
              <label>180 days (regular price)</label>
              <input type="text" v-model="item.renewPrice2Eur" />
            </div>
            </div>
            <div class="form-row split">
            <div>
              <label>1 year (USD)</label>
              <input type="text" v-model="item.renewPrice3Usd" />
            </div>
            <div>
              <label>1 year (regular price)</label>
              <input type="text" v-model="item.renewPrice3Eur" />
            </div>
            </div>
            <div class="form-row">
              <br />
              <label class="checkbox">
                <input type="checkbox" v-model="item.individual" /><em></em>
                Pay for individual videos
              </label>
              
            </div>
            <div class="form-row">
              <label>Video type</label>
              <select v-model="item.type">
                <option v-for="opt in types" :value="opt.id">{{ opt.title }}</option>
              </select>
              <select v-model="item.type2">
                <option v-for="opt in types" :value="opt.id">{{ opt.title }}</option>
              </select>
              <select v-model="item.type3">
                <option v-for="opt in types" :value="opt.id">{{ opt.title }}</option>
              </select>
              <select v-model="item.type4">
                <option v-for="opt in types" :value="opt.id">{{ opt.title }}</option>
              </select>
              <select v-model="item.type5">
                <option v-for="opt in types" :value="opt.id">{{ opt.title }}</option>
              </select>
              <select v-model="item.type6">
                <option v-for="opt in types" :value="opt.id">{{ opt.title }}</option>
              </select>
            </div>
            <div class="form-row form-row-img">
              <label>Photo</label>
              <img v-if="item.photo" :src="'/files/'+item.photo" alt="" />
              <label v-if="item.photo" style="text-align: center; margin-bottom: 15px">
                <input style="width: auto; height: auto; display: inline-block" type="checkbox" v-model="removePhoto" /> Remove
              </label>
              <input v-else type="file" ref="photoUpload" />
            </div>
            <div class="form-row">
              <label>Description</label>
              <textarea v-model="item.description"></textarea>
            </div>
            </template>
            <div class="form-act">
              <button class="lbtn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
    
  </div>

      
</template>
<script>
import api from './api';
export default {
  props: ["item", "entity"],
  data: ()=>({
    types: [],
    removePhoto: false,
  }),
  methods: {
    async loadTypes() {
      this.types=(await api.list("VideoType")).items;
      this.types.unshift({id: null, title: ""});
    },
    async saveProfile() {
      var item=JSON.parse(JSON.stringify(this.item));
      if (this.removePhoto)
        item.photo=null;
      if (item.id)
        await api.update(this.entity, this.item.id, item);
      else
        item.id=(await api.create(this.entity, item)).id;
      if (this.$refs.photoUpload && this.$refs.photoUpload.files[0]) {
        await api.upload(this.entity, this.item.id, this.$refs.photoUpload.files[0]);
      }
      this.$emit("save");
    },
  },
  created() {
    this.loadTypes();
  },
}
</script>
